import { createSelector } from 'reselect';
import _get from 'lodash/get';

export const geoSelector = state => state.geo;

export const userLocationSelector = createSelector(geoSelector, geo =>
  _get(geo, 'userLocation'),
);

export const suggestPOIsSelector = createSelector(geoSelector, geo =>
  // https://jira.grab.com/browse/DELVEXPS-20672
  // Always use dropoff
  _get(geo, ['suggestPOIs', 'dropoff']),
);

export const savedPOISelector = createSelector(geoSelector, geo =>
  _get(geo, 'savedPOI'),
);

export const favoritePOIsSelector = createSelector(savedPOISelector, savedPOI =>
  _get(savedPOI, 'favoritePOIs'),
);

export const predictPOIsSelector = createSelector(savedPOISelector, savedPOI =>
  _get(savedPOI, 'predictPOIs'),
);

export const poisFromSavedPOISelector = createSelector(
  predictPOIsSelector,
  predictPOIs => predictPOIs,
);

export const addressDetailOverlaySelector = createSelector(
  savedPOISelector,
  savedPOI => _get(savedPOI, 'addressDetailOverlay'),
);

export const currentEditingPOISelector = createSelector(
  savedPOISelector,
  savedPOI => _get(savedPOI, 'currentEditingPOI'),
);
